export function selectClass(error?: string): string {
  return `h-10 w-full rounded-lg border bg-muted px-3.5 py-2 text-sm text-foreground shadow-sm transition-all outline-none hover:border-border hover:bg-card focus:border-blue-500 focus:bg-card focus:ring-2 focus:ring-blue-500/20 ${error ? "border-red-300" : "border-border"}`;
}
